// src/pages/Home.tsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSEO } from '../hooks/useSEO';
import { FRONTEND_URL } from '../config';

const Home: React.FC = () => {
  useSEO({
    title: 'Kostüm Akademi | Antalya Kostüm Kiralama',
    description: 'Antalya’da çocuk ve yetişkin kostüm kiralama: geniş koleksiyon, hijyen garantisi, hızlı teslimat. Kostüm Akademi ile hayalindeki kostümü kolayca kirala.',
    canonical: `${FRONTEND_URL}/`,
    keywords: 'kostüm, kostüm kiralama, antalya kostüm, çocuk kostümü, yetişkin kostümü, aksesuar',
    ogImage: `${FRONTEND_URL}/logo.png`,
    ogType: 'website',
  });

  // Önerilen kostümler
  const featuredCostumes = [
    {
      id: 4,
      name: 'UYUYAN GÜZEL KOSTÜMÜ',
      price: '1.300,00 TL',
      image: 'images/uyuyan_güzel.jpg'
    },
    {
      id: 5,
      name: 'RAPUNZEL KOSTÜMÜ',
      price: '1.300,00 TL',
      image: 'images/rapunzel.jpg'
    },
    {
      id: 2,
      name: 'SİNDİRELLA KOSTÜMÜ',
      price: '1.300,00 TL',
      image: 'images/sindirella.jpg'
    },
    {
      id: 11,
      name: 'ELSA KOSTÜMÜ',
      price: '1.300,00 TL',
      image: 'images/elsa.jpg'
    }
  ];


  return (
    <div className="container">
      {/* Hero Section - Orijinal tasarım */}
      <section
        className="hero"
        style={{
          textAlign: 'center',
          padding: '6rem 0',
          minHeight: '400px',
          backgroundImage: `url(${process.env.PUBLIC_URL}/kostüm.png)`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          borderRadius: 0,
          color: 'white',
          marginBottom: '3rem',
          fontFamily: '"Inter", "Segoe UI", -apple-system, sans-serif',
          position: 'relative',
        }}
      >
        <div style={{ marginTop: '120px' }}>
          <p
            style={{
              fontSize: '1.8rem',
              fontWeight: 300,
              textShadow: '1px 1px 6px rgba(0,0,0,0.5)',
              marginBottom: '12rem',
            }}
          >
            Özel günleriniz için mükemmel kostümler
          </p>

          <Link
            to="/costumes"
            style={{
              fontSize: '1.3rem',
              color: 'white',
              textDecoration: 'underline',
              fontWeight: 500,
              textShadow: '1px 1px 4px rgba(0,0,0,0.4)',
            }}
          >
            Kostümleri Keşfet
          </Link>
        </div>
      </section>

      {/* Yeni bölüm - Sol yazı, sağ kare görsel */}
      <section className="story" style={{ 
        padding: '4rem 0', 
        marginBottom: '4rem',
        fontFamily: '"Inter", "Segoe UI", -apple-system, sans-serif'
      }}>
        <div className="home-section-row" style={{ display: 'flex', alignItems: 'center', minHeight: '500px', gap: '4rem', paddingRight: '2rem' }}>
          {/* Sol taraf - Yazı içeriği */}
          <div className="home-text-col" style={{ flex: 1, display: 'flex', flexDirection: 'column', paddingLeft: '8rem' }}>
            <h1 style={{
              fontSize: '3rem',
              fontWeight: '400',
              color: '#000',
              marginBottom: '2rem',
              lineHeight: '1.2',
              textAlign: 'left',
              fontFamily: '"Playfair Display", "Georgia", serif'
            }}>
              Kostümlerin Bir Hikayesi Olur Mu?
            </h1>
            
            <div style={{ 
              marginBottom: '2rem', 
              fontSize: '1.1rem', 
              color: '#555', 
              lineHeight: '1.8',
              textAlign: 'left',
              fontFamily: '"Inter", "Segoe UI", -apple-system, sans-serif'
            }}>
              <p style={{ marginBottom: '1rem' }}>Eğer hayal gücüyle dikildiyse, evet olur…</p>
              <p style={{ marginBottom: '1rem' }}>Size bir masalı hatırlatır, bir oyunu, belki bir kahramanı…</p>
              <p style={{ marginBottom: '1rem' }}>Bazen bir çizgi filmi, bazen bir doğum günü sabahını…</p>
              <p style={{ marginBottom: '2rem' }}>Şimdi bu hayaller, Kostüm Akademi ile yeniden canlanıyor!</p>
            </div>

            <div style={{ textAlign: 'left' }}>
              <Link
                to="/costumes"
                style={{
                  fontSize: '1.1rem',
                  color: '#668A69',
                  textDecoration: 'underline',
                  fontWeight: '400',
                  cursor: 'pointer'
                }}
              >
                Ürünleri Gör
              </Link>
            </div>
          </div>

          {/* Sağ taraf - Kare Görsel */}
          <div className="home-image-col" style={{ flex: '0 0 400px' }}>
            <div className="home-image-box" style={{
              width: '600px',
              height: '600px',
              position: 'relative',
              borderRadius: '15px',
              overflow: 'hidden',
              boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
            }}>
              <img 
                src={`${process.env.PUBLIC_URL}/images/homepage1.jpg`}
                alt="Kostüm Koleksiyonu"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: '15px'
                }}
              />
              {/* Overlay efekti */}
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'linear-gradient(45deg, rgba(102, 138, 105, 0.1), rgba(102, 138, 105, 0.15))',
                borderRadius: '15px'
              }}></div>
            </div>
          </div>
        </div>
      </section>

      {/* Neden Biz? Bölümü */}
      <section className="why-us" style={{
        padding: '4rem 0',
        marginBottom: '4rem',
        fontFamily: '"Inter", "Segoe UI", -apple-system, sans-serif',
        backgroundColor: '#f8f9fa'
      }}>
        <div className="home-section-row" style={{ display: 'flex', alignItems: 'center', minHeight: '500px', gap: '4rem', paddingRight: '2rem' }}>
          {/* Sol taraf - Yazı içeriği */}
          <div className="home-text-col" style={{ flex: 1, display: 'flex', flexDirection: 'column', paddingLeft: '8rem' }}>
            <h1 style={{
              fontSize: '3rem',
              fontWeight: '400',
              color: '#000',
              marginBottom: '2rem',
              lineHeight: '1.2',
              textAlign: 'left',
              fontFamily: '"Playfair Display", "Georgia", serif'
            }}>
              Neden Kostüm Akademi?
            </h1>
            
            <div style={{ 
              marginBottom: '2rem', 
              fontSize: '1.1rem', 
              color: '#555', 
              lineHeight: '1.8',
              textAlign: 'left',
              fontFamily: '"Inter", "Segoe UI", -apple-system, sans-serif'
            }}>
              <p style={{ marginBottom: '1.5rem' }}>
                <strong style={{ color: '#668A69' }}>Antalya'da Tek Adres:</strong> Şehrimizde kaliteli kostüm kiralama seçeneklerinin sınırlı olduğunun farkındayız. Bu nedenle size en geniş kostüm koleksiyonunu sunuyoruz.
              </p>
              <p style={{ marginBottom: '1.5rem' }}>
                <strong style={{ color: '#668A69' }}>Hijyen Garantisi:</strong> Tüm kostümlerimiz kiralama öncesi özel olarak dezenfekte edilir.
              </p>
              <p style={{ marginBottom: '1.5rem' }}>
                <strong style={{ color: '#668A69' }}>Uygun Fiyat:</strong> Satın alma maliyetinin çok altında, kaliteli bir şekilde kiralayabilirsiniz.
              </p>
              <p style={{ marginBottom: '1.5rem' }}>
                <strong style={{ color: '#668A69' }}>Uzman Danışmanlık:</strong> Etkinliğinize ve bedeninize en uygun kostüm seçiminde rehberlik ediyoruz.
              </p>
              <p style={{ marginBottom: '2rem' }}>
                <strong style={{ color: '#668A69' }}>Hızlı Teslimat:</strong> Antalya genelinde aynı gün teslimat hizmeti sunuyoruz.
              </p>
            </div>

            <div style={{ textAlign: 'left' }}>
              <Link
                to="/costumes"
                style={{
                  fontSize: '1.1rem',
                  color: '#668A69',
                  textDecoration: 'underline',
                  fontWeight: '400',
                  cursor: 'pointer'
                }}
              >
                Kostüm Koleksiyonumuzu Keşfet
              </Link>
            </div>
          </div>

          {/* Sağ taraf - Görsel kısmı */}
          <div className="home-image-col" style={{ flex: '0 0 500px' }}>
            <div className="home-image-box" style={{
              width: '600px',
              height: '650px',
              position: 'relative',
              borderRadius: '15px',
              overflow: 'hidden',
              boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
            }}>
              <img 
                src={`${process.env.PUBLIC_URL}/images/neden_kostüm_akademi.jpg`}
                alt="Kostüm Akademi Hakkımızda"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: '15px'
                }}
              />
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'linear-gradient(45deg, rgba(102, 138, 105, 0.1), rgba(102, 138, 105, 0.15))',
                borderRadius: '15px'
              }}></div>
            </div>
          </div>
        </div>
      </section>

      {/* Sizin İçin Seçtiklerimiz Bölümü - Güncellenmiş Tasarım */}
      <section className="featured-costumes" style={{
        padding: '4rem 0',
        marginBottom: '4rem',
        fontFamily: '"Inter", "Segoe UI", -apple-system, sans-serif'
      }}>
        {/* Mobilde üstte gösterilecek başlık */}
        <div className="featured-title-mobile" style={{ display: 'none' }}>
          <h1 className="featured-mobile-heading" style={{
            fontSize: '3rem',
            fontWeight: '400',
            color: '#000',
            marginBottom: '1.25rem',
            lineHeight: '1.2',
            textAlign: 'left',
            fontFamily: '"Playfair Display", "Georgia", serif',
          }}>
            Sizin İçin Seçtiklerimiz
          </h1>
        </div>
        <div className="home-section-row" style={{ display: 'flex', alignItems: 'center', minHeight: '500px', gap: '4rem', paddingLeft: '2rem' }}>
          {/* Sol taraf - Küçültülmüş Kostüm Kartları */}
          <div className="home-cards-col" style={{ flex: '0 0 600px' }}>
            <div className="home-cards-grid" style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              gap: '1.5rem',
              padding: '2rem'
            }}>
              {featuredCostumes.map((costume) => (
                <div key={costume.id} className="home-card" style={{
                  position: 'relative',
                  width: '350px',
                  height: '350px',
                  borderRadius: '20px',
                  overflow: 'hidden',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
                  cursor: 'pointer',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.2)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.15)';
                }}
                >
                  {/* Arka plan görseli */}
                  <img 
                    src={`${process.env.PUBLIC_URL}/${costume.image}`}
                    alt={costume.name}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover'
                    }}
                  />
                  
                  {/* Gradient overlay */}
                  <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'linear-gradient(to bottom, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.3) 60%, rgba(0,0,0,0.8) 100%)',
                    borderRadius: '20px'
                  }}></div>
                  
                  {/* İçerik */}
                  <div style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    padding: '1.5rem',
                    color: 'white',
                    textAlign: 'center'
                  }}>
                    <h3
                      className="featured-card-title"
                      translate="no"
                      style={{
                        fontSize: '1.2rem',
                        fontWeight: '600',
                        marginBottom: '0.8rem',
                        textShadow: '1px 1px 3px rgba(0,0,0,0.5)',
                        fontFamily: '"Inter", "Segoe UI", -apple-system, sans-serif'
                      }}
                    >
                      {costume.name}
                    </h3>
                    
                    <div
                      className="featured-card-price"
                      style={{
                      fontSize: '1.2rem',
                      fontWeight: '700',
                      marginBottom: '1rem',
                      color: 'white',
                      textShadow: '1px 1px 3px rgba(0,0,0,0.5)'
                    }}>
                      {costume.price}
                    </div>
                    
                    <Link
                      className="featured-card-button"
                      to={`/costume/${costume.id}`}
                      style={{
                        backgroundColor: 'rgba(255,255,255,0.9)',
                        color: '#333',
                        border: 'none',
                        padding: '0.6rem 1.5rem',
                        borderRadius: '25px',
                        fontSize: '0.9rem',
                        fontWeight: '600',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        backdropFilter: 'blur(10px)',
                        boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
                        textDecoration: 'none',
                        display: 'inline-block'
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.backgroundColor = '#668A69';
                        e.currentTarget.style.color = 'white';
                        e.currentTarget.style.transform = 'translateY(-2px)';
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.9)';
                        e.currentTarget.style.color = '#333';
                        e.currentTarget.style.transform = 'translateY(0)';
                      }}
                    >
                      İncele
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Sağ taraf - Yazı içeriği */}
          <div className="home-text-col-right" style={{ flex: 1, display: 'flex', flexDirection: 'column', paddingRight: '8rem' }}>
            <h1 className="featured-title-desktop" style={{
              fontSize: '3rem',
              fontWeight: '400',
              color: '#000',
              marginBottom: '2rem',
              lineHeight: '1.2',
              textAlign: 'left',
              fontFamily: '"Playfair Display", "Georgia", serif'
            }}>
              Sizin İçin Seçtiklerimiz
            </h1>
            
            <div style={{ 
              marginBottom: '2rem', 
              fontSize: '1.1rem', 
              color: '#555', 
              lineHeight: '1.8',
              textAlign: 'left',
              fontFamily: '"Inter", "Segoe UI", -apple-system, sans-serif'
            }}>
              <p style={{ marginBottom: '1rem' }}>Hayal Gücünüzü Giyin!</p>
              <p style={{ marginBottom: '1rem' }}>Çocuklar için masallardan, yetişkinler için temalı eğlencelere uzanan kostüm seçeneklerimizle her anı özel kılın.</p>
              <p style={{ marginBottom: '2rem' }}>Kaliteli kumaşlar, özenli tasarımlar ve unutulmaz anlar için buradayız!</p>
            </div>

            <div style={{ textAlign: 'left' }}>
              <Link
                to="/costumes"
                style={{
                  fontSize: '1.1rem',
                  color: '#668A69',
                  textDecoration: 'underline',
                  fontWeight: '400',
                  cursor: 'pointer'
                }}
              >
                Tüm Kostümleri Gör
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section - Yeniden tasarlanmış */}
      <section className="contact" style={{ 
        padding: '4rem 0', 
        marginBottom: '4rem',
        fontFamily: '"Inter", "Segoe UI", -apple-system, sans-serif'
      }}>
        <div className="home-section-row" style={{ display: 'flex', alignItems: 'center', minHeight: '500px', gap: '4rem', paddingLeft: '2rem', paddingRight: '2rem' }}>
          {/* Sol taraf - Yazı içeriği */}
          <div className="home-text-col" style={{ flex: '1.2', display: 'flex', flexDirection: 'column', paddingLeft: '8rem' }}>
            <h1 style={{
              fontSize: '3rem',
              fontWeight: '400',
              color: '#000',
              marginBottom: '2rem',
              lineHeight: '1.2',
              textAlign: 'left',
              fontFamily: '"Playfair Display", "Georgia", serif'
            }}>
              Nasıl Yardımcı Olabiliriz?
            </h1>
            
            <div style={{ 
              marginBottom: '2rem', 
              fontSize: '1.1rem', 
              color: '#555', 
              lineHeight: '1.8',
              textAlign: 'left',
              fontFamily: '"Inter", "Segoe UI", -apple-system, sans-serif'
            }}>
              <p style={{ marginBottom: '1rem' }}>Size özel kostüm önerilerimiz var…</p>
              <p style={{ marginBottom: '1rem' }}>Hangi etkinlik için kostüm arıyorsunuz?</p>
              <p style={{ marginBottom: '1rem' }}>Beden, renk, tema konusunda tavsiyelere ihtiyacınız mı var?</p>
              <p style={{ marginBottom: '2rem' }}>Kostüm Akademi ekibi olarak, size en uygun seçimi yapmanızda yardımcı olmak için buradayız!</p>
            </div>

            <div style={{ textAlign: 'left' }}>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '1rem',
                fontSize: '1rem',
                color: '#555',
                marginBottom: '2rem'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <span style={{ color: '#668A69' }}>📞</span>
                  <span>0(501) 568 50 55</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <span style={{ color: '#668A69' }}>✉️</span>
                  <span>kostumakademi@gmail.com</span>
                </div>
              </div>
            </div>
          </div>

          {/* Sağ taraf - WhatsApp İletişim */}
          <div className="home-contact-col" style={{ flex: '0 0 350px' }}>
            <div className="home-contact-form" style={{
              width: '600px',
              background: 'white',
              borderRadius: '15px',
              padding: '2rem',
              boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
            }}>
              <h3 style={{
                fontSize: '1.8rem',
                fontWeight: '600',
                color: '#2c3e50',
                marginBottom: '1.5rem',
                fontFamily: '"Inter", "Segoe UI", -apple-system, sans-serif'
              }}>
                WhatsApp ile İletişime Geçin
              </h3>

              <div style={{ 
                padding: '1.5rem', 
                backgroundColor: '#f8fafc', 
                borderRadius: '12px',
                border: '1px solid #e2e8f0',
                textAlign: 'center',
                marginBottom: '1.5rem'
              }}>
                <div style={{ 
                  fontSize: '1.1rem', 
                  color: '#374151', 
                  marginBottom: '1.5rem',
                  lineHeight: '1.6'
                }}>
                  Kostüm kiralama ve satın alma konularında sorularınız için WhatsApp üzerinden bizimle iletişime geçebilirsiniz.
                </div>
                <button
                  onClick={() => {
                    window.open('https://wa.me/905015685055?text=Merhaba, kostüm kiralama konusunda bilgi almak istiyorum.', '_blank');
                  }}
                  style={{
                    width: '100%',
                    padding: '1rem 2rem',
                    backgroundColor: '#668A69',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '1.1rem',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'background-color 0.2s ease',
                    fontFamily: '"Inter", "Segoe UI", -apple-system, sans-serif',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.5rem'
                  }}
                  onMouseOver={(e) => (e.target as HTMLButtonElement).style.backgroundColor = '#567a5a'}
                  onMouseOut={(e) => (e.target as HTMLButtonElement).style.backgroundColor = '#668A69'}
                >
                  💬 WhatsApp ile İletişime Geç
                </button>
                <div style={{ 
                  fontSize: '0.9rem', 
                  color: '#6b7280', 
                  marginTop: '1rem',
                  fontStyle: 'italic'
                }}>
                  Hızlı yanıt için WhatsApp tercih edilir
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
